import angular from 'angular';

import ViewTeacherAccountController from './view-teacher-account-controller';

const viewTeacherAccount = angular.module('viewTeacherAccount', []);
viewTeacherAccount.controller('ViewTeacherAccountController', ViewTeacherAccountController);

export default viewTeacherAccount.name;
